import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=bab59838&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=bab59838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab59838",
  null
  
)

export default component.exports